var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUilFileExport2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    d: "M13.947 10.413c-.034-.08-.081-.155-.14-.22l-2-2c-.262-.261-.686-.261-.947 0-.261.262-.261.686 0 .947l.867.86H8c-.368 0-.667.298-.667.667 0 .368.299.666.667.666h3.727l-.867.86c-.126.126-.197.296-.197.474 0 .177.07.348.197.473.125.126.296.197.473.197.178 0 .348-.07.474-.197l2-2c.061-.063.11-.138.14-.22.066-.162.066-.344 0-.507zm-4.614 2.92H4c-.368 0-.667-.298-.667-.666V3.333c0-.368.299-.666.667-.666h3.333v2c0 1.104.896 2 2 2H12c.27-.002.511-.165.613-.414.105-.248.05-.535-.14-.726l-4-4c-.055-.052-.118-.095-.186-.127h-.06l-.187-.067H4c-1.105 0-2 .896-2 2v9.334c0 1.104.895 2 2 2h5.333c.369 0 .667-.299.667-.667 0-.368-.298-.667-.667-.667zm-.666-9.726l1.726 1.726h-1.06c-.368 0-.666-.298-.666-.666v-1.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUilFileExport2);
export default __webpack_public_path__ + "static/media/uil-file-export-2.f10fc46c8fbce28cf21c9718dcebcd93.svg";
export { ForwardRef as ReactComponent };